<app-grid-modal
  i18n-header
  header="Sales Order Line Allocations"
  [columnDefs]="columnDefs"
  [summaryTop]="model"
  [rowData$]="rowData$"
  [showDelete]="showDelete"
  [summaryItems]="summaryItems"
  (delete)="delete($event)"
></app-grid-modal>
